import { Key } from 'lucide-react';

import { UserId } from '@/portainer/users/types';

import { Datatable } from '@@/datatables';
import { createPersistedStore } from '@@/datatables/types';
import { useTableState } from '@@/datatables/useTableState';

import { useAccessTokens } from '../../access-tokens/queries/useAccessTokens';

import { columns } from './columns';
import { TableActions } from './TableActions';

const accountTableKey = 'access-tokens';
const accountStore = createPersistedStore(accountTableKey);
const userTableKey = 'user-access-tokens';
const userStore = createPersistedStore(userTableKey);

export function AccessTokensDatatable({
  userId,
  showAdd = true,
  addTo,
}: {
  userId?: UserId;
  showAdd?: boolean;
  addTo?: string;
} = {}) {
  const query = useAccessTokens(userId);
  const tableState = useTableState(
    userId === undefined ? accountStore : userStore,
    userId === undefined ? accountTableKey : userTableKey
  );

  return (
    <Datatable
      columns={columns}
      isLoading={query.isLoading}
      dataset={query.data || []}
      settingsManager={tableState}
      title="Access tokens"
      titleIcon={Key}
      renderTableActions={(selectedItems) => (
        <TableActions
          selectedItems={selectedItems}
          userId={userId}
          showAdd={showAdd}
          addTo={addTo}
        />
      )}
      data-cy="access-tokens-datatable"
    />
  );
}
